import { render } from "./smallSize.vue?vue&type=template&id=4d9de980&scoped=true"
import script from "./smallSize.vue?vue&type=script&lang=js"
export * from "./smallSize.vue?vue&type=script&lang=js"

import "./smallSize.vue?vue&type=style&index=0&id=4d9de980&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9de980"]])

export default __exports__